import { gql } from '@apollo/client';

export const VALUATION_MUTATION = gql`
  mutation Valuation($input: LeadInput!) {
    lead(input: $input) {
      valuation {
        success
      }
    }
  }
`;
